import { render, staticRenderFns } from "./deviceName.vue?vue&type=template&id=0518e2d1&scoped=true&"
import script from "./deviceName.vue?vue&type=script&lang=js&"
export * from "./deviceName.vue?vue&type=script&lang=js&"
import style0 from "./deviceName.vue?vue&type=style&index=0&id=0518e2d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0518e2d1",
  null
  
)

export default component.exports